<template>
  <VCard
    flat
    class="d-flex flex-column justify-center align-center grey lighten-4 fill-height pt-6 pt-lg-9 pb-6 pb-lg-9 px-2" width="100%"
  >
    <svg width="40" height="35" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path style="fill: red" d="M19 4.5L15 8.5V5C15 4.45 14.55 4 14 4H7.82L19 15.18V4.5ZM1.27 0L0 1.27L2.73 4H2C1.45 4 1 4.45 1 5V15C1 15.55 1.45 16 2 16H14C14.21 16 14.39 15.92 14.54 15.82L17.73 19L19 17.73L1.27 0Z" fill="white" />
    </svg>
    <span class="subitle-1 text-center mt-6 font-weight-medium">
      {{ $t('videoProcessingFailed') }}
    </span>
  </VCard>
</template>

<script>
export default {
  name: 'CandidateInterviewHasNotOpened',
};
</script>

<i18n locale="en" lang="yaml">
videoProcessingFailed: The interview is still not opened. You can ask sender to open it.
</i18n>

<i18n locale="ru" lang="yaml">
videoProcessingFailed: К сожалению, интервью пока не открыто. Вы можете попросить отправителя открыть его.
</i18n>
